export default __webpack_public_path__ + "static-bigflip/media/online-umkm-2.1d8e8d08.webp";